import { useState } from 'react';

import calendar from '~/assets/icons/calendar.svg';
import { playSound, Sound } from '~/assets/sounds';
import { TextInput } from '~/components/ui/TextInput';
import {
	StyledContainer,
	StyledDaysLabel,
	StyledIcon,
	StyledRightContainer,
	StyledTextLabel,
} from './DaysInput.styled';

interface IDaysInputProps extends React.HTMLAttributes<HTMLDivElement> {
	value: number;
	changeHandler: any;
	payDays: number;
	maxDays: number;
}

const DaysInput: React.FC<IDaysInputProps> = ({
	value,
	changeHandler,
	payDays,
	maxDays,
}: IDaysInputProps) => {
	const [focus, setFocus] = useState<boolean>(false);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			if (changeHandler) {
				changeHandler(1);
			}
			return;
		}

		if (parseInt(inputValue) > maxDays - payDays) {
			changeHandler(maxDays - payDays);
			return;
		}

		changeHandler(parseInt(inputValue));
	};

	return (
		<StyledContainer onMouseEnter={() => playSound(Sound.LinkCursor)}>
			<div
				style={{ position: 'relative', display: 'inline-block', width: '100%' }}
			>
				<TextInput
					height={60}
					fontSize={16}
					onChange={onChange}
					value={value}
					onFocus={() => setFocus(true)}
					onBlur={() => setFocus(false)}
					tabIndex={-1}
					active={value > 0}
					padding="0 60px 0 20px"
				/>
				{!focus && (
					<StyledDaysLabel
						style={{
							left: `${value.toString().length * 8 + 28}px`,
						}}
					>
						д.
					</StyledDaysLabel>
				)}
			</div>
			<StyledRightContainer>
				<StyledTextLabel>
					<span>{payDays}</span>
					<span>&nbsp;/ {maxDays}</span>
				</StyledTextLabel>
				<StyledIcon src={calendar} />
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { DaysInput };
